// DMK — hide any 'Sold out' badge, since all products are made-to-order.
(function() {
  function hideSoldOutBadges() {
    var badges = document.querySelectorAll('.product-badges__badge, .badge, [class*="badge"]');
    badges.forEach(function(b) {
      var text = (b.textContent || '').trim().toLowerCase();
      if (text === 'sold out' || text === 'soldout' || text === 'tükendi') {
        b.style.display = 'none';
        // Also hide its parent product-badges container if empty
        var parent = b.closest('.product-badges, product-badges');
        if (parent && Array.from(parent.children).every(function(c) { return c.style.display === 'none'; })) {
          parent.style.display = 'none';
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideSoldOutBadges);
  } else {
    hideSoldOutBadges();
  }
  var mo = new MutationObserver(function() { hideSoldOutBadges(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
